import Player from 'video.js/dist/types/player';

/**
 * Disables Chromecast / AirPlay remote playback on a media element.
 * Chrome otherwise exposes cast UI for any playing video/audio element.
 */
export function disableMediaElementRemotePlayback(mediaEl: HTMLMediaElement) {
  mediaEl.disableRemotePlayback = true;
  mediaEl.setAttribute('x-webkit-airplay', 'deny');
}

/**
 * Disables Chromecast / AirPlay on the Video.js HTML5 tech element.
 */
export function disableVideoJsRemotePlayback(player: Player) {
  const techEl = player.el()?.querySelector('video, audio') as HTMLMediaElement | null;
  if (!techEl) {
    return;
  }
  disableMediaElementRemotePlayback(techEl);
}
